import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["aside", "label", "logo", "logoCollapsed", "labelCollapsed", "toggleBtn"]

  connect() {
    this._mobile = () => window.matchMedia("(max-width: 767px)").matches
    // On mobile, always start collapsed regardless of stored preference
    this.collapsed = this._mobile() || localStorage.getItem("sideNavCollapsed") === "1"
    this._apply()

    this._onResize = () => {
      const wasMobile = this._wasMobile
      const isMobile = this._mobile()
      if (isMobile && !this.collapsed) { this.collapsed = true; this._apply() }
      if (!isMobile && wasMobile) {
        this.collapsed = localStorage.getItem("sideNavCollapsed") === "1"
        this._apply()
      }
      this._wasMobile = isMobile
    }
    this._wasMobile = this._mobile()
    window.addEventListener("resize", this._onResize)
  }

  disconnect() {
    if (this._onResize) window.removeEventListener("resize", this._onResize)
  }

  toggle() {
    this.collapsed = !this.collapsed
    // Only persist preference on desktop
    if (!this._mobile()) {
      localStorage.setItem("sideNavCollapsed", this.collapsed ? "1" : "0")
    }
    this._apply()
  }

  _apply() {
    const aside = this.hasAsideTarget ? this.asideTarget : this.element
    if (this.collapsed) {
      aside.classList.remove("w-56")
      aside.classList.add("w-14")
      this.labelTargets.forEach(el => el.classList.add("hidden"))
      if (this.hasLogoTarget) this.logoTarget.classList.add("hidden")
      if (this.hasLogoCollapsedTarget) this.logoCollapsedTarget.classList.remove("hidden")
      if (this.hasLabelCollapsedTarget) this.labelCollapsedTarget.classList.remove("hidden")
      if (this.hasToggleBtnTarget) this.toggleBtnTarget.classList.add("hidden")
      document.body.classList.remove("md:pl-56")
      document.body.classList.add("md:pl-14")
    } else {
      aside.classList.remove("w-14")
      aside.classList.add("w-56")
      this.labelTargets.forEach(el => el.classList.remove("hidden"))
      if (this.hasLogoTarget) this.logoTarget.classList.remove("hidden")
      if (this.hasLogoCollapsedTarget) this.logoCollapsedTarget.classList.add("hidden")
      if (this.hasLabelCollapsedTarget) this.labelCollapsedTarget.classList.add("hidden")
      if (this.hasToggleBtnTarget) this.toggleBtnTarget.classList.remove("hidden")
      document.body.classList.remove("md:pl-14")
      document.body.classList.add("md:pl-56")
    }
  }
}
